import { Component, OnDestroy, OnInit } from '@angular/core';
import { InterestedHostClient, WebinarRoomFFLImage } from '../Services/WOWApi.Service';
import { CommonService } from '../Services/common.service';
import { Subscription } from 'rxjs';
import moment from 'moment';

@Component({
    selector: 'app-ffl-images',
    templateUrl: './ffl-images.component.html',
    styleUrls: ['./ffl-images.component.css'],
    standalone: false
})
export class FflImagesComponent implements OnInit, OnDestroy {
 
  fflImageList: WebinarRoomFFLImage[] = [];
  isMobileView = false;
  subscription: Subscription;
  constructor(private interestedHost: InterestedHostClient, private commonService: CommonService) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.interestedHost.getFFLImages(0).subscribe(response => {
      this.fflImageList = response;
       
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkBgColor(date: Date) {
    const diffDays = moment(new Date()).diff(date, 'days');
    const isDiff0to15Days = diffDays > 0 && diffDays <= 15 ? true : false;
    const isDiff16To30Days = diffDays > 15 && diffDays <= 30 ? true : false;
    const isDiff1To3Month = diffDays > 30 && diffDays <= 90 ? true : false;
    const isDiffMonthMoreThn3 = diffDays > 90 ? true : false;
    
    if (isDiff0to15Days) {
      return '#f44336';
    } else if (isDiff16To30Days) {
      return '#ffdddd';
    } else if (isDiff1To3Month) {
      return '#ffeb3b';
    } else if (isDiffMonthMoreThn3) {
      return '#dd1608';
    } else {
      return 'whitesmoke';
    }
    
  }
}
